import { Loader, Text } from "@mantine/core"
import { useTranslation, UseTranslationResponse } from "react-i18next"

import { FindContactsByCreatedByIdResponseDto } from "~/gen/api"
import { useFindContactsByCreatedById } from "~/gen/api/hooks/useFindContactsByCreatedById"
import { useTraceabilityOperations } from "~/pages/SupplierPortal/TraceabilityRequests/context/useTraceabilityOperations"
import { useInformationRequestContext } from "~/pages/SupplierPortal/TraceabilityRequests/store/InformationRequestContext"
import { OperationItem } from "~/pages/SupplierPortal/TraceabilityRequests/utils"
import { useAuth } from "~/store/auth-context.tsx"

export const OperationNotOwner = () => {
  const { t } = useTranslation(["traceability"])
  const { user } = useAuth()

  const { data: contacts, isPending: isLoading } = useFindContactsByCreatedById(
    user?.organization?.id ?? "",
    {
      query: {
        enabled: !!user?.organization?.id,
      },
    }
  )
  const { isAdmin } = useInformationRequestContext()
  const { operationItem } = useTraceabilityOperations()
  if (isLoading) return <Loader />

  if (!contacts) return null

  const ownerEmail = getOwnerEmail(operationItem, isAdmin, contacts.data, t)
  return (
    <Text size="sm" w="100%" style={{ textAlign: "center" }}>
      {t("operation.notOwner", {
        email: ownerEmail,
      })}
    </Text>
  )
}

const getOwnerEmail = (
  operationItem: OperationItem,
  isAdmin: boolean,
  contacts: FindContactsByCreatedByIdResponseDto[],
  t: UseTranslationResponse<["traceability"], undefined>["t"]
) => {
  return (
    (isAdmin
      ? operationItem?.operation?.owner?.email
      : contacts?.find((c) => c.user.id === operationItem.operation?.owner.id)
          ?.user.email) ?? t("operation.unknown")
  )
}
